import alt from 'components/Dispatcher';

class InProgressReviewActions {
  constructor() {
    this.generateActions([
      'initialize',
      'getInProgressReviews',
      'setInProgressReview',
      'deleteInProgressReview',
    ]);
  }

  initialize(user) {
    return dispatch => {
      dispatch(user);
    };
  }

  setInProgressReview(inProgressReview, user) {
    return dispatch => {
      dispatch({inProgressReview, user});
    };
  }

  deleteInProgressReview(reviewId, user) {
    return dispatch => {
      dispatch({reviewId, user});
    };
  }
}

export default alt.createActions(InProgressReviewActions);
